"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
function formatDate(dateString) {
    var _a;
    var date = new Date(dateString);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    var lang = (_a = document.documentElement.getAttribute('lang')) !== null && _a !== void 0 ? _a : undefined;
    return date.toLocaleDateString(lang, options);
}
function GetNewsletters() {
    var _a;
    var _b = (0, react_1.useState)([]), newsletters = _b[0], setNewsletters = _b[1];
    var _c = (0, react_1.useState)(true), isLoading = _c[0], setIsLoading = _c[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/api/v2/students/minister")
            .then(function (response) {
            setNewsletters(response.data.minister.newsletters);
            setIsLoading(false);
        })
            .catch(function (error) {
            console.log(error);
            setIsLoading(false);
        });
    }, []);
    if (isLoading)
        return react_1.default.createElement("div", null, "Loading...");
    if (!newsletters || newsletters.length === 0)
        return react_1.default.createElement("div", null, (0, Lang_js_1.__)('No Newsletters Available'));
    var altImage = ((_a = document.getElementById('newsletters')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-alt-image')) + 'images/logo_purple_medium.png';
    return (react_1.default.createElement("div", { className: "container student-container-downloads" },
        react_1.default.createElement("div", { className: "downloads-grid" }, newsletters.map(function (newsletter) {
            var _a;
            return (react_1.default.createElement("div", { key: newsletter.id, className: "downloads-grid-key" },
                react_1.default.createElement("img", { src: ((_a = newsletter.image_url) !== null && _a !== void 0 ? _a : '').replace('www.msia.org', 'cdn.msia.org'), alt: newsletter.title, className: "newsletter-image", onError: function (event) {
                        event.currentTarget.src = altImage;
                        event.currentTarget.onerror = null;
                    } }),
                react_1.default.createElement(Link_1.default, { href: newsletter.file_url, underline: "hover" },
                    react_1.default.createElement(Typography_1.default, { variant: "h6" }, (0, Lang_js_1.__)('CLICK TO DOWNLOAD'))),
                react_1.default.createElement(Typography_1.default, { variant: "body2" }, newsletter.description)));
        }))));
}
exports.default = GetNewsletters;
var newslettersContainer = document.getElementById('newsletters');
if (newslettersContainer) {
    (0, mountIsland_1.mountIsland)(newslettersContainer, react_1.default.createElement(GetNewsletters, null));
}
